import { render, staticRenderFns } from "./englishLock.vue?vue&type=template&id=86996ab2&scoped=true"
import script from "./englishLock.vue?vue&type=script&lang=js"
export * from "./englishLock.vue?vue&type=script&lang=js"
import style0 from "./englishLock.vue?vue&type=style&index=0&id=86996ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86996ab2",
  null
  
)

export default component.exports